import React, {useState} from "react";
import {AiFillLike, AiOutlineLike, AiOutlineShareAlt} from "react-icons/ai";
import {FaBookmark, FaRegBookmark} from "react-icons/fa";

import {bookmarkContent, getContentUrl, likeContent} from "../service";
import useStore from "../../../store/useStore";
import {sendMessageToParent} from "../../../utils/helper";
import {isZymedApp} from "../../../utils/appConfig";
import axios from "axios";
import {saveAs} from "file-saver";
import {FiDownload} from "react-icons/fi";
import { getAppName } from "../../../utils/appConfig";
import {pediaArticleMinutesSoFar, pediaContentAttrs, trackZymedEvent, ZYMED_EVENTS} from "../../../utils/zymedAnalytics";

interface Props {
  type?: number;
  contentDetails: any;
  setContentDetails: any;
  isVisible?: boolean;
}

const LikeShareBookmark: React.FC<Props> = (Props) => {

    const {type, contentDetails, setContentDetails, isVisible} = Props
    const {tatvaPediaToken} = useStore();
    const getToken = () => localStorage.getItem("tatvaPediaToken") || tatvaPediaToken;
    const token = getToken();
    const [timeOutId, setTimeOutId] = useState<any>(null)

    const handleLike = () => {
        if (timeOutId) {
            clearTimeout(timeOutId);
        }
        setTimeOutId(setTimeout(async () => {
            let likeOrNot = !contentDetails?.isLike
            if (likeOrNot) {
                trackZymedEvent(ZYMED_EVENTS.PEDIA_LIKE_ARTICLE, {
                    ...pediaContentAttrs(contentDetails),
                    duration_spent: pediaArticleMinutesSoFar(),
                });
            }
            contentDetails.isLike = !contentDetails?.isLike;
            likeOrNot ? contentDetails.likeCount += 1 : contentDetails.likeCount -= 1;
            setContentDetails((prev: any) => {
                return {
                    ...prev,
                };
            });
            const res: any = await likeContent(contentDetails?.id, contentDetails?.contentTypeId, likeOrNot, token);
            if (!res?.status) {
                contentDetails.isLike = !contentDetails?.isLike;
                likeOrNot ? contentDetails.likeCount -= 1 : contentDetails.likeCount += 1;
                setContentDetails((prev: any) => {
                    return {
                        ...prev,
                    };
                });
            }
        }, 200));
    };

    const onDownloadClick = async () => {
        trackZymedEvent(ZYMED_EVENTS.PEDIA_ARTICLE_DOWNLOADED, pediaContentAttrs(contentDetails));
        const res: any = await getContentUrl(
            contentDetails?.id,
            contentDetails?.contentTypeId,
            contentDetails?.uploadContentUrl,
            token
        );

        if (res !== undefined && res.hasOwnProperty("signedUrl")) {
            if (isZymedApp()) {
                sendMessageToParent("download", {url: res?.signedUrl});
            } else {
                try {
                    const response = await axios({
                        url: res?.signedUrl,
                        method: "GET",
                        responseType: "blob",
                    });

                    const blob = new Blob([response.data], {
                        type: response.headers["content-type"],
                    });
                    // saveAs(blob, `${Date.now()}.pdf`);
                    saveAs(blob, contentDetails?.uploadContentUrl);
                } catch (error) {
                    console.error("Error downloading file:", error);
                }
            }
        }
    };

  const handleBookmark = () => {
    if (timeOutId) {
      clearTimeout(timeOutId);
    }
    setTimeOutId(
      setTimeout(async () => {
        let bookmarkOrNot = !contentDetails?.isBookmark;
        if (bookmarkOrNot) {
          trackZymedEvent(ZYMED_EVENTS.PEDIA_SAVE_TO_LIBRARY, pediaContentAttrs(contentDetails));
        }
        contentDetails.isBookmark = !contentDetails?.isBookmark;
        setContentDetails((prev: any) => {
          return {
            ...prev,
          };
        });
        const res: any = await bookmarkContent(
          contentDetails?.id,
          contentDetails?.contentTypeId,
          bookmarkOrNot,
          token
        );
        if (!res?.status) {
          contentDetails.isBookmark = !contentDetails?.isBookmark;
          setContentDetails((prev: any) => {
            return {
              ...prev,
            };
          });
        }
      }, 200)
    );
  };

  const handleShare = async () => {
    // Create a better sharing message with content details
    const shareTitle = contentDetails?.contentTitle || "Check this out!";

    // Use public preview URL if content is externally shareable, otherwise use current URL
    let shareUrl = window.location.href;
    if (contentDetails?.isExternalSharable) {
      // Create public preview URL - you'll need to implement this route
      shareUrl = `${window.location.origin}/preview/${getAppName()}/${contentDetails.deepLinkCode}/${contentDetails.id}`;
    }

    trackZymedEvent(ZYMED_EVENTS.PEDIA_SHARE_ARTICLE, {
      ...pediaContentAttrs(contentDetails),
      // The sheet that follows is the OS one, which never reports the app picked.
      share_channel: typeof navigator.share === "function" ? "system_share_sheet" : "link",
    });

    sendMessageToParent("share", {
      title: shareTitle,
      url: shareUrl,
    });

    if (navigator.share) {
      try {
        await navigator.share({
          title: shareTitle,
          url: shareUrl,
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    }
  };

    return (
        type ? (
            <div className="py-3 flex items-center">
                <div
                    className="bg-[#F1F1F5] text-[#5A6774] w-[70px] text-[16px] font-medium me-2 px-3 h-[36px] rounded-full flex items-center justify-center cursor-pointer"
                    onClick={handleLike}>
                    {!contentDetails?.isLike ?
                        <AiOutlineLike className="text-[20px] me-1"/> :
                        <AiFillLike className="text-[20px] me-1 text-primary"/>
                    }
                    <div>{contentDetails?.likeCount > 0 ? contentDetails.likeCount : ""}</div>
                </div>
                {contentDetails?.isExternalSharable && (
                    <div onClick={handleShare}
                         className="bg-[#F1F1F5] text-[#5A6774] w-[90px] text-[14px] font-medium mx-2 px-3 h-[36px] rounded-full flex items-center">
                        <AiOutlineShareAlt className="text-[20px] me-1"/> Share
                    </div>
                )}
                <div
                    className="bg-[#F1F1F5] text-[#5A6774] items-center mx-2 justify-center flex h-[38px] w-[38px] rounded-full cursor-pointer"
                    onClick={handleBookmark}>
                    {!contentDetails?.isBookmark ?
                        <FaRegBookmark className="text-[18px]"/> :
                        <FaBookmark className="text-[18px] text-primary"/>
                    }
                </div>
                {contentDetails?.isDownload &&
                    contentDetails?.uploadContentUrl
                        .split(".")
                        .pop()
                        .toLowerCase() === "pdf" && (
                        <div
                            className="bg-[#F1F1F5] text-[#5A6774] items-center mx-2 justify-center flex h-[38px] w-[38px] rounded-full cursor-pointer"
                            onClick={onDownloadClick}>
                            <FiDownload className={"text-[18px]"}/>
                        </div>
                    )}
            </div>
        ) : (
            <div
                className={`py-3 flex items-center justify-center sticky bottom-0 transition-all duration-500 ease-in-out transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`}
            >
                <div
                    className="bg-[#454551] text-white w-fit text-[16px] font-medium mx-3 px-3 h-[36px] rounded-full flex items-center cursor-pointer"
                    onClick={handleLike}>
                    {!contentDetails?.isLike ?
                        <AiOutlineLike className="text-[20px] me-1"/> :
                        <AiFillLike className="text-[20px] me-1 text-primary"/>
                    }
                    <div>{contentDetails?.likeCount > 0 ? contentDetails.likeCount : ""}</div>
                </div>
                {contentDetails?.isExternalSharable && (
                    <div onClick={handleShare}
                         className="bg-[#454551] text-white w-fit text-[14px] font-medium mx-3 px-3 h-[36px] rounded-full flex items-center">
                        <AiOutlineShareAlt className="text-[20px] me-1"/> Share
                    </div>
                )}
                <div
                    className="bg-[#454551] text-white w-fit text-[14px] font-medium mx-3 px-3 h-[36px] rounded-full flex items-center cursor-pointer"
                    onClick={handleBookmark}>
                    {/* <CiBookmark className="text-[20px] me-1" /> Bookmark */}
                    {!contentDetails?.isBookmark ?
                        <FaRegBookmark className="text-[18px]"/> :
                        <FaBookmark className="text-[18px] text-primary"/>
                    }
                </div>

            </div>
        )
    )
}

export default React.memo(LikeShareBookmark);
